import { render, staticRenderFns } from "./TosfList.vue?vue&type=template&id=98231212&scoped=true"
import script from "./TosfList.vue?vue&type=script&lang=js"
export * from "./TosfList.vue?vue&type=script&lang=js"
import style0 from "./TosfList.vue?vue&type=style&index=0&id=98231212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98231212",
  null
  
)

export default component.exports